import '../../style/index.less';
import './index.less';



// WEBPACK FOOTER //
// ./components/multipleinput/style/index.tsx